import React, { useState } from "react";
import { Card, CardContent } from "./components/ui/card";
import "./App.css";
const Cart = ({ cart, setCart, onCheckout }) => {
  const updateQuantity = (index, change) => {
    const updatedCart = [...cart];
    updatedCart[index].quantity += change;
    if (updatedCart[index].quantity <= 0) {
      updatedCart.splice(index, 1); // Remove item if quantity is 0
    }
    setCart(updatedCart);
  };

  const totalPrice = cart.reduce((total, item) => total + item.price * item.quantity, 0).toFixed(2);

  return (
    <div className="bg-black text-gold p-6 min-h-screen">
      <h1 className="text-3xl font-bold mb-4 text-center">Your Cart</h1>
      {cart.length === 0 ? (
        <p className="text-center text-xl">Your cart is empty.</p>
      ) : (
        <div className="Display-Flex">
          {cart.map((item, index) => (
            <Card key={index} className="bg-gray-900 p-4 rounded-lg shadow-md border border-gold">
              <CardContent>
                <h2 className="text-xl font-bold text-gold">{item.name}</h2>
                {/* <p className="text-lg text-gray-400">Price: ${item.price}</p> */}
                <p className="text-lg text-gray-400">Quantity: {item.quantity}</p>
                <div className="flex gap-2 mt-2">
                  <button className="button" onClick={() => updateQuantity(index, -1)}>-</button>
                  <button className="button" onClick={() => updateQuantity(index, 1)}>+</button>
                </div>
              </CardContent>
            </Card>
          ))}
	      <h2 className="text-2xl font-bold text-gold mt-4">Total: {(totalPrice*89500)%5000>2500 ? ((totalPrice*89500)-(totalPrice*89500)%5000+5000):((totalPrice*89500)-(totalPrice*89500)%5000)}</h2>
 {/* <h2 className="text-2xl font-bold text-gold mt-4">Total: {(totalPrice)} $</h2> */}
          <button onClick={onCheckout} className="button">Proceed to Checkout</button>
        </div>
      )}
    </div>
  );
};

export default Cart;

